import React from 'react';
import Link from 'next/link';
import { GlobalPage } from '../components/GlobalPage.jsx';
import { Container, Layout } from '../components/layout/';
import { ArticlePage } from '../components/ArticlePage.jsx';

export default function ContactUsPage() {
  return (
    <GlobalPage
      title="Kom i kontakt med Penger.no"
      description="Penger.no er et samarbeid mellom redaksjonene i VG, E24 og Dine Penger. Penger.no gir deg argumentene du trenger for å få et billigere boligllån. Tjenesten er eid av Schibsted."
      canonical="/kontakt"
    >
      <Layout>
        <Container>
          <ArticlePage>
            <h1>Kom i kontakt</h1>
            <p>
              Penger.no er en tjeneste som er utviklet og driftet av VG Lab, en
              underavdeling i Verdens Gang As. Selskapet er eid av Schibsted
              Media Group.
            </p>
            <p>
              Vi vil veldig gjerne høre fra deg, enten det er ris, ros eller
              gode idéer på funksjoner eller forbedringer av våre tjenester. Vi
              svarer så raskt vi kan på alle tilbakemeldinger.
            </p>
            <p>
              <b>E-post</b>:
              <br />
              <a href="mailto:hei@vglab.no">hei@vglab.no</a>
            </p>
            <p>
              <b>Postadresse:</b>
              <br />
              Verdens Gang AS
              <br />
              Postboks 1185
              <br />
              Sentrum 0107 Olso
            </p>
            <p>
              Har du generelle spørsmål om hvordan tjenesten virker?{' '}
              <Link href="/om-tjenesten">
                <a>Les om tjenesten »</a>
              </Link>
            </p>
          </ArticlePage>
        </Container>
      </Layout>
    </GlobalPage>
  );
}
